/**
 * /tracking/events - event-based tracking page (feat #169).
 *
 * Declares a TanStack Router route and renders `EventTrackingPage`. The root
 * wire-up cycle picks this route up after the prod merge; agents never edit
 * router.tsx directly.
 */
import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { EventTrackingPage } from "@/features/event-tracking/EventTrackingPage";

// ---------------------------------------------------------------------------
// Route - mounts at `/tracking/events`.
// ---------------------------------------------------------------------------

export const trackingEventsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/events",
	component: TrackingEventsRoute,
});

export default trackingEventsRoute;

// ---------------------------------------------------------------------------
// Page shell - breadcrumb + feature component.
// ---------------------------------------------------------------------------

export function TrackingEventsRoute() {
	return (
		<div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-6 pt-6 sm:pt-10">
			<Breadcrumb />
			<EventTrackingPage />
		</div>
	);
}

function Breadcrumb() {
	return (
		<nav aria-label="Breadcrumb" className="text-sm text-zinc-500">
			<ol className="flex flex-wrap items-center gap-1">
				<li>
					<Link
						to="/"
						className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
					>
						Dashboard
					</Link>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li>
					<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li className="text-zinc-900">Events</li>
			</ol>
		</nav>
	);
}
